"use client";

import {
  Dialog,
  DialogPortal,
  DialogBackdrop,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogBody,
  DialogClose,
  Alert,
} from "@/ui";
import CVUpload from "@components/CV/Upload";

export default function AddCandidateCV({ onClose, open }) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogPortal>
        <DialogBackdrop />
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Add candidate via CV</DialogTitle>
            <DialogDescription>
              Upload a PDF or DOCX CV to add a candidate.
            </DialogDescription>
            <DialogClose />
          </DialogHeader>
          <DialogBody>
            <Alert variant="info" title="Tip" style={{ marginBottom: 24 }}>
              The original CV will give better results than a formatted or branded CV
            </Alert>
            <CVUpload onUploadComplete={onClose} />
          </DialogBody>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
